import styled from 'styled-components'
import { theme } from '../../theme/themeProvider'

export const AppVersionWrap = styled.div`
	padding: 0 0 8px 0;
	font-family: ${theme.typography.allVariants.fontFamily};
	font-size: 0.5rem;
	color: ${theme.palette.lightGray.main};
`
